__turbopack_context__.v({
  "arrayTextField": "clientDetails-module-scss-module__a_8hlG__arrayTextField",
  "buttons-container": "clientDetails-module-scss-module__a_8hlG__buttons-container",
  "buttons-container-centre": "clientDetails-module-scss-module__a_8hlG__buttons-container-centre",
  "buttons-container-row": "clientDetails-module-scss-module__a_8hlG__buttons-container-row",
  "cancel-button": "clientDetails-module-scss-module__a_8hlG__cancel-button",
  "content": "clientDetails-module-scss-module__a_8hlG__content",
  "content-container": "clientDetails-module-scss-module__a_8hlG__content-container",
  "edit-icon": "clientDetails-module-scss-module__a_8hlG__edit-icon",
  "edit-icon-error": "clientDetails-module-scss-module__a_8hlG__edit-icon-error",
  "fade-in-unwkr5o": "clientDetails-module-scss-module__a_8hlG__fade-in-unwkr5o",
  "fade-in-unwkr66": "clientDetails-module-scss-module__a_8hlG__fade-in-unwkr66",
  "fade-in-unwkr6t": "clientDetails-module-scss-module__a_8hlG__fade-in-unwkr6t",
  "header-with-button": "clientDetails-module-scss-module__a_8hlG__header-with-button",
  "icon": "clientDetails-module-scss-module__a_8hlG__icon",
  "icon-not-verified": "clientDetails-module-scss-module__a_8hlG__icon-not-verified",
  "icon-verified": "clientDetails-module-scss-module__a_8hlG__icon-verified",
  "main": "clientDetails-module-scss-module__a_8hlG__main",
  "navButton": "clientDetails-module-scss-module__a_8hlG__navButton",
  "phone-container": "clientDetails-module-scss-module__a_8hlG__phone-container",
  "radio-buttons-container": "clientDetails-module-scss-module__a_8hlG__radio-buttons-container",
  "radio-buttons-padding": "clientDetails-module-scss-module__a_8hlG__radio-buttons-padding",
  "section-content": "clientDetails-module-scss-module__a_8hlG__section-content",
  "section-title": "clientDetails-module-scss-module__a_8hlG__section-title",
  "status": "clientDetails-module-scss-module__a_8hlG__status",
  "text": "clientDetails-module-scss-module__a_8hlG__text",
  "text-not-verified": "clientDetails-module-scss-module__a_8hlG__text-not-verified",
  "text-row": "clientDetails-module-scss-module__a_8hlG__text-row",
  "text-verified": "clientDetails-module-scss-module__a_8hlG__text-verified",
  "text-width": "clientDetails-module-scss-module__a_8hlG__text-width",
  "title": "clientDetails-module-scss-module__a_8hlG__title",
  "title-container": "clientDetails-module-scss-module__a_8hlG__title-container",
});
